class CustomBundle extends HTMLElement {
  constructor() {
    super();
    this.selectedItems = [];
    this.packSizes = { 12: 3, 16: 4, 24: 6, 48: 12 };
    this.currentPack = 12;
    this.maxItems = this.packSizes[this.currentPack];
    this._detailsScrollHandler = null;
  }

  async getBundleData() {
    const bundleDataResponse = await fetch(
      "https://hunni-serverless.vercel.app/api/ghia/bundle-data"
    );
    const bundleData = await bundleDataResponse.json();
    this.bundleData = bundleData;
  }

  async connectedCallback() {
    await this.getBundleData();
    this.buttons = this.querySelectorAll(".add-to-bundle-js");
    this.bundleContainer = this.querySelector(".bundle-container-js");
    this.packButtons = this.querySelectorAll(".tab-input-button");
    this.bundleDetailsContainer = this.querySelector(
      ".bundle-details-container"
    );
    this.variantSelect = document.querySelector("#variant-select");
    this.pricesContainer = this.querySelectorAll(".prices-container-js");
    this.variantBundlePrice = this.querySelectorAll(".variant-price-bundle-js");
    this.variantBundlePriceDiscount = this.querySelectorAll(
      ".variant-price-discount-bundle-js"
    );
    this.purchaseOptions = this.querySelectorAll(".purchase-option");
    this.openModalDetailsButton = this.querySelector(".open-modal-details-js");
    this.modalDetails = this.querySelector(".mobile-details-js");
    this.modalArrow = this.querySelector(".open-modal-arrow-js");
    this.remainingItemsText = this.querySelector(".remaining-items-text-js");

    this.buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        this.addItem(event);
        this.modalDetails.classList.remove("h-0");
        this.modalArrow.classList.remove("rotate-180");
      });
    });

    this.packButtons.forEach((button) => {
      button.addEventListener("click", (event) => this.changePack(event));
    });

    this.updateBundle();
    this.updateActivePack();

    document
      .querySelector("custom-bundle")
      .addEventListener("bundleUpdated", (event) => {
        this.selectedItems = event.detail.selectedItems;
      });

    this.variantPriceEl = this.querySelector("#variant-price");

    this.variantBundlePrice.forEach((el) => {
      el.innerHTML = this.variantPriceEl?.innerHTML || "";
    });

    this.variantBundlePriceDiscount.forEach((el) => {
      el.innerHTML = "";
    });

    this.updatePriceUi();

    this.purchaseOptions.forEach((button) => {
      button.addEventListener("click", () => {
        setTimeout(() => {
          this.updatePriceUi();
        }, 100);
      });
    });

    this.toggleDetailsModalMobile();
    this.emptyProductAction();
  }

  toggleDetailsModalMobile() {
    this.openModalDetailsButton.addEventListener("click", () => {
      this.modalDetails.classList.toggle("h-0");
      this.modalArrow.classList.toggle("rotate-180");
    });
  }

  emptyProductAction() {
    this.emptyProducts = this.querySelectorAll(".empty-product-js");

    this.emptyProducts.forEach((button) => {
      button.addEventListener("click", () => {
        this.modalDetails.classList.add("h-0");
        this.modalArrow.classList.add("rotate-180");

        const firstProduct = document.querySelector(".product-container");
        if (firstProduct) {
          firstProduct.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      });
    });
  }

  updatePriceUi() {
    const activeButton = this.querySelector(".tab-input-button.active");

    if (!activeButton) return;

    const basePrice = activeButton.dataset.price || "";
    const compareAtPrice = activeButton.dataset.compareAtPrice || "";
    const subscriptionDiscount =
      activeButton.dataset.subscriptionDiscount || "";

    const bundleForm = this.querySelector(
      ".add-to-cart-container-js clover-product-item"
    );

    const subscriptionRadio = bundleForm
      ? bundleForm.querySelector('[id^="subscribe-save-"]:checked')
      : null;

    const isSubscriptionSelected =
      subscriptionDiscount && subscriptionRadio !== null;

    let displayPrice = basePrice;
    let displayComparePrice = compareAtPrice;

    if (isSubscriptionSelected && subscriptionDiscount) {
      const discountPercent = parseFloat(subscriptionDiscount);
      const basePriceValue = parseFloat(basePrice.replace(/[^\d.]/g, ""));
      const discountedPriceValue = basePriceValue * (1 - discountPercent / 100);

      const priceMatch = basePrice.match(/^([^\d.,]*)[\d.,]+([^\d.,]*)$/);
      if (priceMatch) {
        const prefixSymbol = priceMatch[1];
        const suffixSymbol = priceMatch[2];
        const formattedValue = discountedPriceValue
          .toFixed(2)
          .replace(/\.00$/, "");
        displayPrice = prefixSymbol + formattedValue + suffixSymbol;
      } else {
        displayPrice =
          "$" + discountedPriceValue.toFixed(2).replace(/\.00$/, "");
      }

      if (!compareAtPrice) {
        displayComparePrice = basePrice;
      }
    }

    const hasDiscount =
      displayComparePrice &&
      parseFloat(displayComparePrice.replace(/[^\d.]/g, "")) >
        parseFloat(displayPrice.replace(/[^\d.]/g, ""));

    const finalDiscount = this.querySelector(".final-discount");
    if (finalDiscount) {
      finalDiscount.innerHTML = subscriptionDiscount + "%";
    }

    this.pricesContainer.forEach((container) => {
      container.classList.toggle("subscription-active", hasDiscount);
    });

    this.variantBundlePrice.forEach((el) => {
      el.innerHTML = displayPrice;
    });

    this.variantBundlePriceDiscount.forEach((el) => {
      el.innerHTML = hasDiscount ? `<s>${displayComparePrice}</s>` : "";
    });
  }

  changePack(event) {
    const newPack = parseInt(
      event.target.dataset.packSize || event.target.textContent.match(/\d+/)[0],
      10
    );
    if (this.packSizes[newPack]) {
      this.currentPack = newPack;
      this.maxItems = this.packSizes[this.currentPack];
      this.selectedItems = this.selectedItems.slice(0, this.maxItems);
      this.updateBundle();
      this.dispatchSelectedItems();
      this.updateActivePack();
      this.updateVariantSelect(newPack);

    }
  }

  updateVariantSelect(packSize) {
    setTimeout(() => {
      this.updatePriceUi();
    }, 100);

    this.emptyProductAction();

    if (!this.variantSelect) return;
    const options = this.variantSelect.querySelectorAll("option");
    options.forEach((option) => {
      const size = parseInt(option.textContent.replace(/[^0-9]/g, ""), 10);
      if (size === packSize) {
        this.variantSelect.value = option.value;
        this.variantSelect.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      }
    });
  }

  updateActivePack() {
    this.packButtons.forEach((button) => {
      button.classList.remove("active");
      const packSize = parseInt(button.textContent.match(/\d+/)[0], 10);
      if (packSize === this.currentPack) {
        button.classList.add("active");
      }
    });
  }

  addItem(event) {
    if (this.selectedItems.length >= this.maxItems) return;

    const button = event.target;
    const productContainer = button.closest(".product-container");
    const productTitle = productContainer.dataset.productTitle;
    const productImage =
      productContainer.querySelector(".product-image-js").src;
    const productId = productContainer.dataset.productId;

    this.selectedItems.push({
      id: productId,
      title: productTitle,
      image: productImage,
    });
    this.updateBundle();
    this.dispatchSelectedItems();
    this.emptyProductAction();
  }

  getGridTemplate() {
    // 12 pack (3 items): 1 centered row of 3 in a 4-col grid
    // 16 pack (4 items): 1 row of 4
    // 24 pack (6 items): 2 centered rows of 3 in a 4-col grid
    // 48 pack (12 items): 3 rows of 4
    const templates = {
      12: {
        columns: "repeat(4, 1fr)",
        areas: '". a b c ."',
        areaNames: ["a", "b", "c"],
        actualCols: 5,
      },
      16: {
        columns: "repeat(4, 1fr)",
        areas: '"a b c d"',
        areaNames: ["a", "b", "c", "d"],
      },
      24: {
        columns: "repeat(4, 1fr)",
        areas: '". a b c ." ". d e f ."',
        areaNames: ["a", "b", "c", "d", "e", "f"],
        actualCols: 5,
      },
      48: {
        columns: "repeat(4, 1fr)",
        areas: '"a b c d" "e f g h" "i j k l"',
        areaNames: ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l"],
      },
    };
    return templates[this.currentPack];
  }

  updateBundle() {
    this.bundleContainer.innerHTML = "";
    this.bundleContainer.style.maxWidth = "";

    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    const template = this.getGridTemplate();

    if (isDesktop && template) {
      this.bundleContainer.style.display = "grid";
      this.bundleContainer.style.gridTemplateColumns = template.actualCols ? `repeat(${template.actualCols}, 1fr)` : template.columns;
      this.bundleContainer.style.gridTemplateAreas = template.areas;
      this.bundleContainer.style.gap = "16px";
    } else {
      this.bundleContainer.style.display = "";
      this.bundleContainer.style.gridTemplateColumns = "";
      this.bundleContainer.style.gridTemplateAreas = "";
      this.bundleContainer.style.gap = "";
    }

    for (let i = 0; i < this.maxItems; i++) {
      const div = document.createElement("div");
      div.classList.add(
        "w-[80px]",
        "h-[80px]",
        "shrink-0",
        "lg:h-auto",
        "relative",
        "leading-none"
      );
      if (isDesktop && template) {
        div.style.gridArea = template.areaNames[i];
      }
      if (this.selectedItems[i]) {
        div.innerHTML = `
          <img src="${this.selectedItems[i].image}" alt="${this.selectedItems[i].title}" class="product-selected-img rounded-lg mask--clover-diamond object-cover object-center" >
          <button style="transform: translate(-50%, 20%);" class="absolute bottom-0 left-1/2 -translate-x-1/2 bg-cream p-1 rounded-full text-xs remove-btn" data-index="${i}">
            <svg class="w-6" style="transform: rotate(45deg);" width="28" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="25" cy="25" r="22" stroke="#5A192A" stroke-width="4"/>
              <line stroke-linecap="round" x1="25" y1="12" x2="25" y2="38" stroke="#5A192A" stroke-width="4"/>
              <line stroke-linecap="round" x1="12" y1="25" x2="38" y2="25" stroke="#5A192A" stroke-width="4"/>
            </svg>
          </button>
        `;
      } else {
        div.innerHTML = `
          <button type="button" class="empty-product-js relative w-full h-full">
            <svg class="lg:w-full" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M33.7832 1L1 32.1654L28.3204 58.5704C11.801 65.5696 1.00002 77.1686 1.00002 90.2934C1.00002 111.67 29.6536 129 65 129C100.346 129 129 111.67 129 90.2934C129 77.1686 118.199 65.5696 101.679 58.5704L129 32.1654L96.2166 1H70.2092H59.7905H33.7832Z" fill="" stroke="#651C32" stroke-width="2" stroke-dasharray="4"/>
            </svg>
            <svg class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2" width="16" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="25" cy="25" r="22" stroke="#5A192A" stroke-width="4"/>
            <line stroke-linecap="round" x1="25" y1="12" x2="25" y2="38" stroke="#5A192A" stroke-width="4"/>
            <line stroke-linecap="round" x1="12" y1="25" x2="38" y2="25" stroke="#5A192A" stroke-width="4"/>
            </svg>
          </button>
        `;
      }
      this.bundleContainer.appendChild(div);
    }

    this.bundleContainer.querySelectorAll(".remove-btn").forEach((button) => {
      button.addEventListener("click", (event) => this.removeItem(event));
    });

    this.updateMessage();
  }

  removeItem(event) {
    const index = event.target.closest(".remove-btn").dataset.index;
    this.selectedItems.splice(index, 1);
    this.updateBundle();
    this.dispatchSelectedItems();
    this.emptyProductAction();
  }

  updateMessage() {
    const messageElement = this.querySelector(".remaining-items-js");
    const remaining = this.maxItems - this.selectedItems.length;

    if (remaining > 0) {
      messageElement.textContent = `Pick ${remaining} ${
        remaining === 1 ? "flavor" : "flavors"
      } to create your bundle.`;
      this.remainingItemsText.textContent = `Select ${remaining} of any flavors`;
      messageElement.classList.add("mx-auto");
      messageElement.classList.add("text-center");
      this.bundleDetailsContainer.classList.remove("active-add-to-cart-js");
    } else {
      this.remainingItemsText.textContent = `Spritz Selection Set`;
      const countMap = {};
      this.selectedItems.forEach((item) => {
        if (!countMap[item.title]) {
          countMap[item.title] = 1;
        } else {
          countMap[item.title]++;
        }
      });

      const titleList = Object.entries(countMap)
        .map(
          ([title, count]) =>
            `${count} ${title.replace("- 4 Pack", "").replace("- 4 pack", "")}`
        )
        .join(", ");

      messageElement.innerHTML = `<span style="font-size: 12px">${titleList}</span>`;
      messageElement.classList.remove("mx-auto");
      messageElement.classList.remove("text-center");
      messageElement.classList.remove("max-w-[300px]");

      this.bundleDetailsContainer.classList.add("active-add-to-cart-js");
    }
  }

  dispatchSelectedItems() {
    this.dispatchEvent(
      new CustomEvent("bundleUpdated", {
        detail: { selectedItems: this.selectedItems },
        bubbles: true,
        composed: true,
      })
    );
  }
}

customElements.define("custom-bundle", CustomBundle);
